export const translations = {
  en: {
    // Nav
    nav_overview:    '📊 Overview',
    nav_chat:        '🤖 Guardian Agent',
    nav_mothers:     '👩 Mothers',
    nav_calendar:    '💉 Vaccination Calendar',
    nav_delivery:    '📦 Kit Delivery',
    nav_audit:       '🔍 Health Audit',
    nav_kits:        '🛒 Kit Requests',
    nav_sessions:    '📋 Agent Sessions',
    nav_appointments:'🏥 Appointments',
    nav_reminders:   '🔔 Reminders',
    nav_shop:        '🛍️ Shop',
    nav_analytics:   '📈 Analytics',
    nav_version:     '🔍 Version & Diagnostics',
    // Topbar
    app_subtitle:    'Multi-Agent System v4',
    api_label:       'API',
    // Overview
    total_mothers:   'Total Mothers',
    registered:      'Registered in system',
    high_risk:       'High Risk',
    needs_attention: 'Needs immediate attention',
    no_bpjs:         'No BPJS',
    not_registered:  'Not registered',
    pregnant:        '🤰 Pregnant',
    infant:          '👶 Infant (0-12 mo)',
    toddler:         '🧒 Toddler (1-2 yr)',
    active_alerts:   '🔔 Active Alerts',
    no_alerts:       'No active alerts',
    // Mothers table
    mothers_list:    'Mothers List',
    name:            'Name',
    age:             'Age',
    phase:           'Phase',
    days:            'Days',
    region:          'Region',
    bpjs:            'BPJS',
    risk:            'Risk',
    action:          'Action',
    detail:          'Detail',
    active:          'Active',
    inactive:        'Inactive',
    phase_pregnancy: '🤰 Pregnant',
    phase_infant:    '👶 Infant',
    phase_toddler:   '🧒 Toddler',
    yrs:             'yrs',
    // Agent Chat
    mother_label:    'Mother:',
    chat_welcome:    '👋 Hello! I am the NutriSakti Guardian Agent.\n\nTry typing:\n• "I ate moringa but feel dizzy"\n• "request prenatal kit"\n• "check bpjs status"\n• "audit all mothers"\n• "my baby has fever, book a doctor"\n• "show my vaccination schedule"\n• "buy baby milk" or "order diapers"',
    processing:      '⏳ Processing multi-agent workflow...',
    send:            'Send',
    type_message:    'Type a message...',
    agent_log:       'Agent Execution Log',
    send_to_see_log: 'Send a message to see the log',
    session_label:   'Session',
    intents_label:   'Intents',
    // Kit Requests
    request_kit:     '🛒 Request New Kit (LogisticsAgent)',
    kit_stats:       '📊 Kit Statistics',
    total_requests:  'Total requests',
    usdc_total:      'Total USDC',
    kit_history:     'Kit Request History',
    no_requests:     'No requests yet',
    kit_prenatal:    'Prenatal Care Kit ($25 USDC)',
    kit_delivery:    'Safe Delivery Kit ($35 USDC)',
    kit_newborn:     'Newborn Essentials ($20 USDC)',
    kit_nutrition:   'Nutrition Support Kit ($15 USDC)',
    request_btn:     '📦 Request Kit (DID + USDC Escrow)',
    requesting:      '⏳ Processing...',
    did_verified:    'DID Verified',
    usdc_escrowed:   'USDC Escrowed',
    time:            'Time',
    status:          'Status',
    // Health Audit
    audit_all:       'Audit All Mothers (HealthAuditAgent)',
    audit_detail:    'Audit Detail',
    audit_btn:       'Audit',
    close:           'Close',
    risks_label:     'Risks',
    upcoming_milestones: 'Upcoming Milestones',
    days_until:      'days until',
    day_label:       'Day',
    loading:         '⏳ Loading...',
    needs_attn_yes:  '⚠️ Yes',
    needs_attn_no:   '✅ No',
    // Sessions
    session_history: 'Agent Session History',
    no_sessions:     'No sessions yet. Try the Guardian Agent Chat.',
    expand:          'Expand',
    collapse:        'Collapse',
    // Vaccination Calendar
    vacc_title:      'Vaccination Calendar',
    total_scheduled: 'Total Scheduled',
    given:           '✅ Given',
    planned:         '📅 Planned',
    filter_title:    'Filter Vaccination Calendar',
    filter_status:   'Status',
    filter_type:     'Vaccine Type',
    filter_puskesmas:'Health Center',
    filter_name:     'Vaccine Name',
    all:             'All',
    taken:           '✅ Given',
    planned_btn:     '📅 Planned',
    mandatory:       '💉 Mandatory',
    booster:         '🔄 Booster',
    prenatal_type:   '🤰 Prenatal',
    all_centers:     'All Health Centers',
    search_vaccine:  'Search vaccine...',
    reset:           '↺ Reset',
    vacc_table_title:'Vaccination Schedule',
    entries:         'entries',
    col_mother:      'Mother',
    col_vaccine:     'Vaccine',
    col_type:        'Type',
    col_status:      'Status',
    col_date:        'Date',
    col_center:      'Health Center',
    col_notes:       'Notes',
    overdue:         '⚠️ Overdue',
    no_data:         'No data matching these filters',
    // Kit Delivery
    delivery_title:  'Kit Delivery Tracking',
    delivered:       '✅ Delivered',
    in_transit:      '🚚 In Transit',
    ordered:         '📋 Ordered',
    failed:          '❌ Failed',
    delivery_rate:   'Delivery Success Rate',
    filter_delivery: 'Filter Delivery Tracking',
    filter_status_d: 'Delivery Status',
    filter_kit_type: 'Kit Type',
    all_statuses:    'All Statuses',
    all_kits:        'All Kits',
    kit_prenatal_s:  '🤰 Prenatal',
    kit_delivery_s:  '🏥 Delivery',
    kit_newborn_s:   '👶 Newborn',
    kit_nutrition_s: '🥗 Nutrition',
    delivery_table:  'Delivery History',
    col_kit:         'Kit',
    col_ordered:     'Ordered',
    col_dispatched:  'Dispatched',
    col_received:    'Received',
    col_days:        'Days',
    col_proof:       'Proof',
    days_label:      'days',
    // Settings
    settings:        'Settings',
    language:        'Language',
    theme:           'Theme',
    dark_mode:       'Dark Mode',
    light_mode:      'Light Mode',
    // Appointments
    appt_title:      'Doctor & Emergency Appointments',
    appt_book:       '🏥 Book Appointment',
    appt_emergency:  '🚨 Emergency',
    appt_urgent:     '⚠️ Urgent',
    appt_routine:    '📅 Routine',
    appt_confirmed:  '✅ Confirmed',
    appt_scheduled:  '📋 Scheduled',
    appt_cancelled:  '❌ Cancelled',
    appt_doctor:     'Doctor',
    appt_reason:     'Reason',
    appt_when:       'Scheduled',
    appt_type:       'Type',
    appt_filter_all: 'All Types',
    appt_stats:      'Appointment Summary',
    appt_total:      'Total',
    appt_today:      'Today / Emergency',
    appt_upcoming:   'Upcoming',
    appt_no_data:    'No appointments yet',
    appt_book_btn:   '+ Book via Chat',
    // Reminders
    rem_title:       'Vaccination Reminders',
    rem_today:       '🔴 Today',
    rem_soon:        '🟡 This Week',
    rem_upcoming:    '🟢 Upcoming',
    rem_overdue:     '⚠️ Overdue',
    rem_sent:        '✅ Sent',
    rem_pending:     '⏳ Pending',
    rem_vaccine:     'Vaccine',
    rem_due:         'Due Date',
    rem_days_left:   'Days Left',
    rem_no_data:     'No reminders. Ask Guardian Agent: "show my vaccination schedule"',
    rem_filter_all:  'All Mothers',
    // Shop
    shop_title:      'NutriSakti Shop',
    shop_subtitle:   'Delivered to your door',
    shop_all:        'All Products',
    shop_milk:       '🥛 Milk',
    shop_biscuit:    '🍪 Biscuits',
    shop_diaper:     '👶 Diapers',
    shop_vitamin:    '💊 Vitamins',
    shop_price:      'Price',
    shop_stock:      'Stock',
    shop_order_btn:  '🛒 Order via Chat',
    shop_orders:     'My Orders',
    shop_order_id:   'Order ID',
    shop_total:      'Total',
    shop_status:     'Status',
    shop_address:    'Delivery Address',
    shop_ordered:    '📋 Ordered',
    shop_transit:    '🚚 In Transit',
    shop_delivered:  '✅ Delivered',
    shop_no_orders:  'No orders yet. Ask Guardian Agent to order products!',
    shop_how:        'How to order: type "buy [product]" or "order PRD001 2 pcs" in Guardian Agent chat',
    // Analytics
    bi_title:           'Business Intelligence Dashboard',
    bi_subtitle:        'Real-time insights across all NutriSakti modules',
    bi_kpi:             'Key Performance Indicators',
    bi_health:          'Health & Risk',
    bi_vaccination:     'Vaccination Coverage',
    bi_logistics:       'Logistics & Delivery',
    bi_commerce:        'Commerce',
    bi_agents:          'AI Agent Activity',
    bi_risk_region:     'Risk Distribution by Region',
    bi_phase_dist:      'Mother Phase Distribution',
    bi_vacc_coverage:   'Vaccination Coverage by Vaccine',
    bi_delivery_perf:   'Kit Delivery Performance',
    bi_shop_perf:       'Shop Revenue by Category',
    bi_appt_summary:    'Appointment Summary',
    bi_agent_sessions:  'Agent Session Activity',
    bi_coverage_rate:   'Coverage Rate',
    bi_delivery_rate:   'Delivery Rate',
    bi_success_rate:    'Success Rate',
    bi_completion:      'Completion',
    bi_revenue:         'Revenue (USDC)',
    bi_orders:          'Orders',
    bi_sessions:        'Sessions',
    bi_export:          '⬇ Export CSV',
    bi_refresh:         '↺ Refresh',
    bi_last_updated:    'Last updated',
    bi_no_data:         'No data available',
    bi_high:            'High Risk',
    bi_medium:          'Medium Risk',
    bi_low:             'Low Risk',
    bi_bpjs_covered:    'BPJS Covered',
    bi_bpjs_uncovered:  'BPJS Uncovered',
    bi_overdue_vacc:    'Overdue Vaccinations',
    bi_emergency_appts: 'Emergency Appts',
    bi_pending_rem:     'Pending Reminders',
    bi_avg_order:       'Avg Order Value',
  },
  id: {
    nav_overview:    '📊 Ringkasan',
    nav_chat:        '🤖 Guardian Agent',
    nav_mothers:     '👩 Daftar Ibu',
    nav_calendar:    '💉 Kalender Vaksinasi',
    nav_delivery:    '📦 Tracking Pengiriman',
    nav_audit:       '🔍 Audit Kesehatan',
    nav_kits:        '🛒 Permintaan Kit',
    nav_sessions:    '📋 Sesi Agent',
    nav_appointments:'🏥 Janji Dokter',
    nav_reminders:   '🔔 Pengingat',
    nav_shop:        '🛍️ Toko',
    nav_analytics:   '📈 Analitik',
    nav_version:     '🔍 Versi & Diagnostik',
    app_subtitle:    'Sistem Multi-Agent v4',
    api_label:       'API',
    total_mothers:   'Total Ibu',
    registered:      'Terdaftar di sistem',
    high_risk:       'Risiko Tinggi',
    needs_attention: 'Perlu perhatian segera',
    no_bpjs:         'Tanpa BPJS',
    not_registered:  'Belum terdaftar',
    pregnant:        '🤰 Hamil',
    infant:          '👶 Bayi (0-12 bln)',
    toddler:         '🧒 Balita (1-2 thn)',
    active_alerts:   '🔔 Alert Aktif',
    no_alerts:       'Tidak ada alert aktif',
    mothers_list:    'Daftar Ibu',
    name:            'Nama',
    age:             'Usia',
    phase:           'Fase',
    days:            'Hari',
    region:          'Wilayah',
    bpjs:            'BPJS',
    risk:            'Risiko',
    action:          'Aksi',
    detail:          'Detail',
    active:          'Aktif',
    inactive:        'Tidak',
    phase_pregnancy: '🤰 Hamil',
    phase_infant:    '👶 Bayi',
    phase_toddler:   '🧒 Balita',
    yrs:             'thn',
    mother_label:    'Ibu:',
    chat_welcome:    '👋 Halo! Saya Guardian Agent NutriSakti.\n\nCoba ketik:\n• "saya makan daun kelor tapi pusing"\n• "minta kit prenatal"\n• "cek status bpjs"\n• "audit semua ibu"\n• "bayi saya demam, pesan dokter"\n• "tampilkan jadwal vaksinasi saya"\n• "beli susu bayi" atau "pesan popok"',
    processing:      '⏳ Memproses multi-agent workflow...',
    send:            'Kirim',
    type_message:    'Ketik pesan...',
    agent_log:       'Log Eksekusi Agent',
    send_to_see_log: 'Kirim pesan untuk melihat log',
    session_label:   'Sesi',
    intents_label:   'Intent',
    request_kit:     '🛒 Minta Kit Baru (LogisticsAgent)',
    kit_stats:       '📊 Statistik Kit',
    total_requests:  'Total permintaan',
    usdc_total:      'Total USDC',
    kit_history:     'Riwayat Permintaan Kit',
    no_requests:     'Belum ada permintaan',
    kit_prenatal:    'Kit Perawatan Prenatal ($25 USDC)',
    kit_delivery:    'Kit Persalinan Aman ($35 USDC)',
    kit_newborn:     'Perlengkapan Bayi Baru Lahir ($20 USDC)',
    kit_nutrition:   'Kit Dukungan Nutrisi ($15 USDC)',
    request_btn:     '📦 Minta Kit (DID + USDC Escrow)',
    requesting:      '⏳ Memproses...',
    did_verified:    'DID Terverifikasi',
    usdc_escrowed:   'USDC Di-escrow',
    time:            'Waktu',
    status:          'Status',
    audit_all:       'Audit Semua Ibu (HealthAuditAgent)',
    audit_detail:    'Detail Audit',
    audit_btn:       'Audit',
    close:           'Tutup',
    risks_label:     'Risiko',
    upcoming_milestones: 'Milestone Mendatang',
    days_until:      'hari lagi',
    day_label:       'Hari',
    loading:         '⏳ Memuat...',
    needs_attn_yes:  '⚠️ Ya',
    needs_attn_no:   '✅ Tidak',
    session_history: 'Riwayat Sesi Agent',
    no_sessions:     'Belum ada sesi. Coba Guardian Agent Chat.',
    expand:          'Buka',
    collapse:        'Tutup',
    vacc_title:      'Kalender Vaksinasi',
    total_scheduled: 'Total Jadwal',
    given:           '✅ Sudah Diberikan',
    planned:         '📅 Direncanakan',
    filter_title:    'Filter Kalender Vaksinasi',
    filter_status:   'Status',
    filter_type:     'Jenis Vaksin',
    filter_puskesmas:'Puskesmas',
    filter_name:     'Nama Vaksin',
    all:             'Semua',
    taken:           '✅ Sudah',
    planned_btn:     '📅 Rencana',
    mandatory:       '💉 Wajib',
    booster:         '🔄 Lanjutan',
    prenatal_type:   '🤰 Prenatal',
    all_centers:     'Semua Puskesmas',
    search_vaccine:  'Cari vaksin...',
    reset:           '↺ Reset',
    vacc_table_title:'Jadwal Vaksinasi',
    entries:         'entri',
    col_mother:      'Ibu',
    col_vaccine:     'Vaksin',
    col_type:        'Jenis',
    col_status:      'Status',
    col_date:        'Tanggal',
    col_center:      'Puskesmas',
    col_notes:       'Catatan',
    overdue:         '⚠️ Terlambat',
    no_data:         'Tidak ada data dengan filter ini',
    delivery_title:  'Tracking Pengiriman Kit',
    delivered:       '✅ Terkirim',
    in_transit:      '🚚 Dalam Perjalanan',
    ordered:         '📋 Dipesan',
    failed:          '❌ Gagal',
    delivery_rate:   'Tingkat Keberhasilan Pengiriman',
    filter_delivery: 'Filter Tracking Pengiriman',
    filter_status_d: 'Status Pengiriman',
    filter_kit_type: 'Jenis Kit',
    all_statuses:    'Semua Status',
    all_kits:        'Semua Kit',
    kit_prenatal_s:  '🤰 Prenatal',
    kit_delivery_s:  '🏥 Persalinan',
    kit_newborn_s:   '👶 Bayi',
    kit_nutrition_s: '🥗 Nutrisi',
    delivery_table:  'Riwayat Pengiriman',
    col_kit:         'Kit',
    col_ordered:     'Dipesan',
    col_dispatched:  'Dikirim',
    col_received:    'Diterima',
    col_days:        'Hari',
    col_proof:       'Bukti',
    days_label:      'hari',
    // Settings
    settings:        'Pengaturan',
    language:        'Bahasa',
    theme:           'Tema',
    dark_mode:       'Mode Gelap',
    light_mode:      'Mode Terang',
    // Appointments
    appt_title:      'Janji Dokter & Darurat',
    appt_book:       '🏥 Buat Janji',
    appt_emergency:  '🚨 Darurat',
    appt_urgent:     '⚠️ Mendesak',
    appt_routine:    '📅 Rutin',
    appt_confirmed:  '✅ Dikonfirmasi',
    appt_scheduled:  '📋 Dijadwalkan',
    appt_cancelled:  '❌ Dibatalkan',
    appt_doctor:     'Dokter',
    appt_reason:     'Alasan',
    appt_when:       'Jadwal',
    appt_type:       'Jenis',
    appt_filter_all: 'Semua Jenis',
    appt_stats:      'Ringkasan Janji',
    appt_total:      'Total',
    appt_today:      'Hari Ini / Darurat',
    appt_upcoming:   'Mendatang',
    appt_no_data:    'Belum ada janji temu',
    appt_book_btn:   '+ Buat via Chat',
    // Reminders
    rem_title:       'Pengingat Vaksinasi',
    rem_today:       '🔴 Hari Ini',
    rem_soon:        '🟡 Minggu Ini',
    rem_upcoming:    '🟢 Mendatang',
    rem_overdue:     '⚠️ Terlambat',
    rem_sent:        '✅ Terkirim',
    rem_pending:     '⏳ Menunggu',
    rem_vaccine:     'Vaksin',
    rem_due:         'Tanggal',
    rem_days_left:   'Sisa Hari',
    rem_no_data:     'Belum ada pengingat. Tanya Guardian Agent: "tampilkan jadwal vaksinasi saya"',
    rem_filter_all:  'Semua Ibu',
    // Shop
    shop_title:      'Toko NutriSakti',
    shop_subtitle:   'Dikirim ke rumah Anda',
    shop_all:        'Semua Produk',
    shop_milk:       '🥛 Susu',
    shop_biscuit:    '🍪 Biskuit',
    shop_diaper:     '👶 Popok',
    shop_vitamin:    '💊 Vitamin',
    shop_price:      'Harga',
    shop_stock:      'Stok',
    shop_order_btn:  '🛒 Pesan via Chat',
    shop_orders:     'Pesanan Saya',
    shop_order_id:   'ID Pesanan',
    shop_total:      'Total',
    shop_status:     'Status',
    shop_address:    'Alamat Pengiriman',
    shop_ordered:    '📋 Dipesan',
    shop_transit:    '🚚 Dalam Perjalanan',
    shop_delivered:  '✅ Terkirim',
    shop_no_orders:  'Belum ada pesanan. Minta Guardian Agent untuk memesan produk!',
    shop_how:        'Cara pesan: ketik "beli [produk]" atau "pesan PRD001 2 buah" di chat Guardian Agent',
    // Analytics
    bi_title:           'Dashboard Business Intelligence',
    bi_subtitle:        'Wawasan real-time seluruh modul NutriSakti',
    bi_kpi:             'Indikator Kinerja Utama',
    bi_health:          'Kesehatan & Risiko',
    bi_vaccination:     'Cakupan Vaksinasi',
    bi_logistics:       'Logistik & Pengiriman',
    bi_commerce:        'Perdagangan',
    bi_agents:          'Aktivitas AI Agent',
    bi_risk_region:     'Distribusi Risiko per Wilayah',
    bi_phase_dist:      'Distribusi Fase Ibu',
    bi_vacc_coverage:   'Cakupan Vaksinasi per Vaksin',
    bi_delivery_perf:   'Performa Pengiriman Kit',
    bi_shop_perf:       'Pendapatan Toko per Kategori',
    bi_appt_summary:    'Ringkasan Janji Temu',
    bi_agent_sessions:  'Aktivitas Sesi Agent',
    bi_coverage_rate:   'Tingkat Cakupan',
    bi_delivery_rate:   'Tingkat Pengiriman',
    bi_success_rate:    'Tingkat Keberhasilan',
    bi_completion:      'Penyelesaian',
    bi_revenue:         'Pendapatan (USDC)',
    bi_orders:          'Pesanan',
    bi_sessions:        'Sesi',
    bi_export:          '⬇ Ekspor CSV',
    bi_refresh:         '↺ Perbarui',
    bi_last_updated:    'Terakhir diperbarui',
    bi_no_data:         'Tidak ada data',
    bi_high:            'Risiko Tinggi',
    bi_medium:          'Risiko Sedang',
    bi_low:             'Risiko Rendah',
    bi_bpjs_covered:    'BPJS Aktif',
    bi_bpjs_uncovered:  'Tanpa BPJS',
    bi_overdue_vacc:    'Vaksinasi Terlambat',
    bi_emergency_appts: 'Janji Darurat',
    bi_pending_rem:     'Pengingat Tertunda',
    bi_avg_order:       'Rata-rata Pesanan',
  }
};
